
import { defineComponent, PropType, ref } from 'vue';

import EasyDrop from '@/components/EasyDrop.vue';
import { SearchFlightRecommendationSortItem } from '@/types/models';
import { useStore } from 'vuex';

export default defineComponent({
  name: "FlightSorting",
  components: {
    EasyDrop
  },
  emits: ['updateFilteredFlights'],
  props: {
    sortItems: {
      type: Array as PropType<Array<SearchFlightRecommendationSortItem>>,
      required: true
    },
    pageTexts: {
      type: Object,
      required: true
    }
  },
  setup(_props, { emit }) {
    const store = useStore();
    const easyDrop = ref();

    const updateSort = (sortItem: SearchFlightRecommendationSortItem) => {
      store.dispatch('TravelSearchBookingModule/updateFilterSort', sortItem).then(() => {
        emit("updateFilteredFlights");
      });
    }

    const closeDropdown = () => {
      if (easyDrop.value)
        easyDrop.value.toggleDropdown();
    }

    return {
      updateSort,
      easyDrop,
      closeDropdown
    }
  },
})
